import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'rpe-perfil-page',
  templateUrl: './perfil-page.component.html',
  styleUrls: ['./perfil-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PerfilPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
